// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"265":"canvg","270":"1644ddea","297":"xlsx","577":"db8cd4b8","640":"8839100a","715":"b157d8df"}[chunkId] + "." + {"265":"22b1f57063da5c3d17d1","270":"be302fbc0f9fa1b3a7c9","297":"d66e50c33ec50cd82f73","577":"1f6812bd05a3b6327213","640":"a9cfe58eb9b7523a8d86","715":"ca5ea8b3ea708774cf6f"}[chunkId] + ".js";
};